import update from "immutability-helper";

import {
  ADD_TAB_HISTORY,
  REMOVE_TAB_HISTORY
} from "../../constants/actionTypes";

const MAX_TABS_NUMBER = 10;

const tabHistory = (state = [], action) => {
  switch (action.type) {
    case ADD_TAB_HISTORY:
      let newState = [action.tab, ...state];
      if (state.length >= MAX_TABS_NUMBER) {
        newState.splice(MAX_TABS_NUMBER, 1);
      }
      return newState;
    case REMOVE_TAB_HISTORY:
      return update(state, { $splice: [[action.index, 1]] });
    default:
      return state;
  }
};

export default tabHistory;
